import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ArBusiness.css";
import ContactFormModal from "../header/ContactFormModal";

const ArBusiness: React.FC = () => {
  const navigate = useNavigate();
  const [showContactForm, setShowContactForm] = useState(false);
  const location = useLocation();

  // Decide background class based on path
  const getBackgroundClass = () => {
    switch (location.pathname) {
      case "/IOT-services":
        return "ar-business-iot";
      case "/Custom-Software":
        return "ar-business-custom";
      case "/AI-ML-Solution":
        return "ar-business-aiandml";
      case "/cloud-services":
        return "ar-business-cloud";
      case "/Data-Management":
        return "ar-business-datasolution";
      default:
        return "ar-business-default";
    }
  };

  return (
    <div className={`ar-business-wrapper ${getBackgroundClass()}`}>
      <div className="ar-business-content">
        <h2 className="ar-h2">Ready to Transform Your Business?</h2>
        <p className="ar-p">
          Let's discuss how our proven process can accelerate your digital
          transformation journey.
        </p>
    <button
      className="cta-button"
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </button>
      </div>
      {showContactForm && (
        <ContactFormModal onClose={() => setShowContactForm(false)} />
      )}
    </div>
  );
};

export default ArBusiness;
